import React from 'react';
import { motion } from 'framer-motion';

const HeroV3 = () => {
  return (
    <section className="w-full rounded-2xl bg-gradient-to-br from-slate-950 via-blue-950 to-indigo-900 text-white">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="space-y-5"
        >
          <p className="text-xs uppercase tracking-[0.2em] text-blue-200 font-semibold">Portfolio V3</p>
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight">Shalender Kumar</h1>
          <p className="text-xl md:text-2xl text-blue-100 font-semibold">Senior Laravel Engineer</p>
          <p className="text-lg text-slate-100/90 max-w-3xl leading-relaxed">
            Engineering scalable SaaS products, performance-first APIs, and resilient backend systems for global businesses.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroV3;
